<template lang="pug">

  #inviteTeamContainer

    v-row

      v-col(cols="12" xs="3" sm="3").align-center.d-flex
        sos-button(@buttonClick="goToGroup" size="medium" buttonLabel="Voltar para o grupo" buttonIcon="mdi-arrow-left" buttonIconSize="16" v-if="groupCreationStep === 'options_invite' && etapa === 'invite'").mr-auto
        sos-button(@buttonClick="goToStep('invite')" size="medium" buttonLabel="Voltar página" buttonIcon="mdi-arrow-left" buttonIconSize="16" v-else-if="etapa !== 'invite'").mr-auto

      v-col(cols="12" xs="6" sm="6").align-start.d-flex
        step-header(v-if="groupCreationStep === 'options_create'" etapa="options")

      v-col(cols="12" xs="3" sm="3").align-center.d-flex
        sos-button(@buttonClick="goToGroup" size="medium" buttonLabel="Pular Etapa" buttonIcon="mdi-arrow-right" iconPosition="right" buttonIconSize="16" v-if="groupCreationStep === 'options_create'").mr-auto

    .inviteBlock(v-if="etapa === 'invite'")

      h3(v-if="groupCreationStep === 'options_create'")
        .inviteTitle
          span O grupo
          span.inviteCreatedGroup
            |  {{ groupName }}
          span  foi criado!
        .inviteSubtitle Agora falta convidar a sua equipe.#[br]Você tem duas opções:

      h3(v-else)
        .inviteTitle
          span CONVIDAR MINHA EQUIPE
        .inviteSubtitle Você tem duas opções:

      .inviteOptions

          .custom-column

            img(src="@/assets/IconeEmail.png" width="80")

            h5.shareTitle
              | E-MAIL

            .shareBody
              p.shareDescription
                //- | Informe o e-mail de cada membro da sua equipe.#[br]Eles serão colocados no grupo e em seguida serão convidados a entrar no aplicativo.
                | Informe o e-mail de cada membro da sua equipe.#[br]Todos serão colocados no grupo. Você poderá gerar uma senha para os novos usuários.
              p.shareDescriptionObservation
                | OBS: Enquanto isso você já pode montar a sua escala com esses membros.

            sos-button(@buttonClick="goToStep('email')" size="medium" buttonLabel="AVANÇAR" buttonIcon="mdi-arrow-right" iconPosition="right" buttonIconSize="16").mr-auto

          .custom-column.custom-column-2
            | OU

          .custom-column

            img(src="@/assets/IconeLink.png" width="80")

            h5.shareTitle
              | LINK

            .shareBody
              p.shareDescription
                | Compartilhe um link com sua equipe.#[br]Eles precisam se cadastrar no seu grupo através do link.
              p.shareDescriptionObservation
                | OBS: Para montar a escala você precisa esperar a equipe entrar no grupo através do link.

            sos-button(@buttonClick="goToStep('link')" size="medium" buttonLabel="AVANÇAR" buttonIcon="mdi-arrow-right" iconPosition="right" buttonIconSize="16").mr-auto

    div(v-else-if="etapa === 'email'")
      send-by-email(@step="goToStep" :groupID="groupID" :groupName="groupName")

    div(v-else-if="etapa === 'link'")
      send-by-link(@step="goToStep" :groupID="groupID")

</template>

<script>

  import { mapState/* , mapMutations */ } from 'vuex'

  import { getGroupByID } from '@/services/firebase'

  import StepHeader from '@/components/StepHeader'
  import SendByEmail from './SendByEmail'
  import SendByLink from './SendByLink'

  import SosButton from '@/components/SosButton'

  export default {
    name: 'InviteTeam',

    components: {
      StepHeader,
      SendByEmail,
      SendByLink,
      'sos-button': SosButton,
    },

    props: {
      groupID: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      etapa: 'invite',
      groupName: '...',
    }),

    computed: {
      ...mapState({
        groupCreationStep: state => state.app.groupCreationStep,
        group: state => state.app.group,
      }),
    },

    watch: {
      '$store.state.app.groupCreationStep': async function () {
        const groupCreationStep = this.$store.state.app.groupCreationStep

        // this.groupCreationStep = groupCreationStep

        if (groupCreationStep === 'options_create' && this.groupID.length > 0) {
          // carregar grupo
          const group = await getGroupByID(this.groupID)
          if (group) {
            this.groupName = Object.prototype.hasOwnProperty.call(group, 'nome') && String(group.nome).trim().length > 0 ? String(group.nome).trim() : '[SEM NOME]'
            // [24/01/25] console.log('::: watch:', this.groupName)
          }
        }

        // [24/01/25] console.log('InviteTeam[watch][groupCreationStep]:', groupCreationStep)
      },
    },

    async mounted () {
      // [24/01/25] const groupCreationStep = this.$store.state.app.groupCreationStep

      // [24/01/25] console.log('InviteTeam[mounted][groupCreationStep]:', groupCreationStep)

      // if (groupCreationStep === 'options_create' && this.groupID.length > 0) {

      if (this.groupID.length > 0)
      {
        // Carregar grupo
        const group = await getGroupByID(this.groupID)

        if (group)
        {
          this.groupName = Object.prototype.hasOwnProperty.call(group, 'nome') && String(group.nome).trim().length > 0 ? String(group.nome).trim() : '[SEM NOME]'
          // [24/01/25] console.log('::: mounted:', this.groupName)
        }
      }
    },

    methods: {
      goToGroup () {
        const groupID = this.$route.params.groupID

        // [24/01/25] console.log('InviteTeam[goToGroup]:', groupID)

        this.$router.push(`/admin/grupos/${groupID}/escalas`)
      },

      goToStep (etapa) {
        this.etapa = etapa
      },
    },
  }

</script>

<style lang="scss" scoped>

  #inviteTeamContainer {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    padding: 0;
    // padding: 20px 30px
  }

  .inviteBlock {
    padding-top: 35px;
    padding-bottom: 70px;
    margin-top: 50px;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

    color: rgba(0, 0, 0, 0.87);
  }

  .inviteTitle {
    padding-top: 7px;
    padding-bottom: 2px;
    color: #3c4858;
    font-size: 25px;
    line-height: 30px;
    font-weight: 500;
    text-align: center;
  }

  .inviteSubtitle {
    padding-top: 25px;
    color: #3c4858;
    font-size: 22px;
    line-height: 30px;
    font-weight: 400;
    text-align: center;
  }

  .shareBody {
    margin-bottom: 35px;
  }

  .shareDescription {
    font-size: 16px;
    font-weight: 300;
  }

  .shareDescriptionObservation {
    font-size: 16px;
    font-weight: 500;
  }

  .header {
    width: 100%;
    text-align: center;
  }

  .inviteCreatedGroup {
    color: mediumseagreen;
  }

  .inviteOptions {
    padding: 0 30px;
    margin-top: 50px;
    font-size: 0;
    text-align: center;
  }

  .custom-column {
    width: 100%;
    max-width: 360px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }

  .custom-column-2 {
    font-size: 25px;
    max-width: 150px;
  }

  @media (max-width: 1164px) {
    .custom-column {
      width: 40%;
      max-width: none;
    }

    .custom-column-2 {
      width: 20%;
      max-width: none;
    }
  }

  @media (max-width: 960px) {
    .inviteOptions {
      padding: 0 20px;
    }

    .custom-column {
      width: 100%;
      max-width: 400px;
    }

    .custom-column-2 {
      width: 100%;
      max-width: none;
      margin-top: 40px;
      margin-bottom: 30px;
    }
  }

</style>
